<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path
			d="M0 8C0 10.12 0.84 12.16 2.34667 13.6533C3.85333 15.16 5.88 16 8 16C10.12 16 12.16 15.16 13.6533 13.6533C15.16 12.1467 16 10.12 16 8C16 5.88 15.16 3.84 13.6533 2.34667C12.1467 0.84 10.12 0 8 0C5.88 0 3.84 0.84 2.34667 2.34667C0.84 3.85333 0 5.88 0 8Z"
			fill="#3DBB3D"
		/>
		<path d="M7.01335 10.5735L4.18668 7.74678" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M11.8133 5.77344L7.01334 10.5734" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'BadgeCheckIcon',
});
</script>
